module.exports = function() {
  return new Worker(__webpack_public_path__ + "f0e68bff5ece3e7e1cc7.worker.js");
};